import { render, staticRenderFns } from "./IndividualStoreConfigurations.vue?vue&type=template&id=58a28d5a&scoped=true"
import script from "./IndividualStoreConfigurations.vue?vue&type=script&lang=js"
export * from "./IndividualStoreConfigurations.vue?vue&type=script&lang=js"
import style0 from "./IndividualStoreConfigurations.vue?vue&type=style&index=0&id=58a28d5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a28d5a",
  null
  
)

export default component.exports